import request from '@/api/http.js'

export function getDivList(query) {
    return request({
        url: 'div',
        method: 'get',
        params: query,
    })
}
export function getdwList(query) {
    return request({
        url: 'divs',
        method: 'get',
        params: query,
    })
}



export function editpwd(query) {
    return request({
        url: 'user/password',
        method: 'post',
        data: query,
    })
}
export function logout(query) {
    return request({
        url: 'user/logout',
        method: 'post',
        data: query,
    })
}
export function login(query) {
    return request({
        url: 'user/login',
        method: 'post',
        data: query,
    })
}

export function editUsername(query) {
    return request({
        url: '/div/edit',
        method: 'post',
        data: query,
    })
}

//导入公开表
export function importTable(params) {
    return request({
        method: 'post',
        url: '/div/import',
        data: params,
    })
}

//列出用户之前导入过的文件
export function importedFiles(params) {
    return request({
        method: 'get',
        url: '/div/importedFiles',
        params: params,
    })
}

//
export function ImportingProfile(params) {
    return request({
        method: 'post',
        url: '/zone/ImportingProfile',
        data: params,
    })
}

//设置cookie
export function setCookie(key, value) {
    let oDate = new Date();
    oDate.setDate(oDate.getDate() + key);
    document.cookie = encodeURI(key) + "=" + value + ";expires=" + oDate.toGMTString();
}
//获取cookie
export function getCookie(key) {
    let arr1 = document.cookie.split("; ");
    for (let i = 0; i < arr1.length; i++) {
        let arr2 = arr1[i].split("=");
        if (arr2[0] == key) {
            return decodeURI(arr2[1]);
        }
    }
}

export function postAsync(params) {
    return request({
        method: 'post',
        url: '/zone/ImportingProfile',
        data: params,
    })
}

export function getAsync(params) {
    return request({
        method: 'get',
        url: '/zone/ImportingProfile',
        data: params,
    })
}


